export function getPayerName({ FirstName, LastName }: { FirstName: string, LastName: string }) {
	return [FirstName, LastName].filter(x => x).join(' ');
}
